"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HiTechLab = void 0;
const Card_1 = require("../Card");
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
const Tags_1 = require("../Tags");
const Resources_1 = require("../../Resources");
const SelectAmount_1 = require("../../inputs/SelectAmount");
const CardRenderer_1 = require("../render/CardRenderer");
class HiTechLab extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.ACTIVE,
            name: CardName_1.CardName.HI_TECH_LAB,
            tags: [Tags_1.Tags.SCIENCE, Tags_1.Tags.BUILDING],
            cost: 17,
            metadata: {
                cardNumber: 'X04',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.action('Spend any amount of energy to draw the same number of cards. TAKE 1 INTO HAND AND DISCARD THE REST.', (eb) => {
                        eb.text('X').energy(1).startAction.text('X').cards(1).asterix();
                    });
                }),
                victoryPoints: 1,
            },
        });
    }
    play() {
        return undefined;
    }
    canAct(player) {
        return player.energy > 0;
    }
    action(player) {
        return HiTechLab.spendEnergyToDrawCards(player);
    }
    getVictoryPoints() {
        return 1;
    }
    static spendEnergyToDrawCards(player) {
        if (player.energy === 1) {
            player.deductResource(Resources_1.Resources.ENERGY, 1);
            player.game.log('${0} spent ${1} energy', (b) => b.player(player).number(1));
            player.drawCard();
            return undefined;
        }
        return new SelectAmount_1.SelectAmount('Select amount of energy to spend', 'Spend energy', (amount) => {
            player.deductResource(Resources_1.Resources.ENERGY, amount);
            player.game.log('${0} spent ${1} energy', (b) => b.player(player).number(amount));
            if (amount === 1) {
                player.drawCard();
                return undefined;
            }
            return player.drawCardKeepSome(amount, { keepMax: 1 });
        }, 1, player.energy);
    }
}
exports.HiTechLab = HiTechLab;
//# sourceMappingURL=HiTechLab.js.map